import { Button, Divider } from "antd";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { Fragment } from "react";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'agentId' implicitly has an 'any' type.
function CardAction({ agentId }) {
  return (
    <Fragment>
      <Button
        data-testid="uploaded-docs-edit"
        aria-label="Edit Uploaded Documents"
        type="link"
        target="_blank"
        href={`/admin/documents/${agentId}`}
      >
        Edit
      </Button>
      <Divider type="vertical" />
      <Button
        data-testid="uploaded-docs-view"
        type="link"
        target="_blank"
        href={`/documents/${agentId}`}
      >
        View
      </Button>
    </Fragment>
  );
}

export { CardAction };
